<template>
  <div class="index-main-container" :class="{'mobile-index-container':isMobile}">
    <IndexHeaderNav v-if="!isMobile && scrollTop>300" style="position: fixed;z-index: 999"/>
    <LayoutMobileHeader v-if="isMobile && scrollTop>200" style="position: fixed;z-index: 999"/>
    <!--    顶部背景-->
    <div class="top-bg" :class="{'mobile-top-bg':isMobile}">
      <div>
        <img src='@/assets/img/index/logo-text.png' alt="">
        <LayoutMobileHeader v-if="isMobile" :type="true"/>
      </div>
      <IndexHeaderNav v-if="!isMobile" :type="true"></IndexHeaderNav>

    </div>
    <div class="main-container" :class="{'mobile-main-container':isMobile}">
      <!--轮播图-->
      <Carousel/>
      <!-- 中间 剩余会员时长/开通会员-->
      <div class="vip-box">
        <!--   这里是两种展现形式 一种是已开通会员 另一种是未开通会员  约定: userInfo.memberFlag为0未开通会员
              1 黄金会员 2 钻石会员
        -->
        <img :src="memberDisplay().icon" alt="">
        <span>{{
            isLogin && userInfo.memberFlag != 0 ? `会员到期时间${userInfo.member.expiryTime},剩余${formatTime()}天` : '仅需198即可观看所有付费课程'
          }}</span>
        <button @click="openAndRenewalCallback">{{
            isLogin && userInfo.memberFlag != 0 ? '续费VIP' : '开通VIP'
          }}
        </button>
      </div>
      <!--直播课程  榜单-->
      <CourseLiveOnline/>
      <div class="sub-container">
        <!--免费课程-->
        <course-list title="免费课程" class-type="free" page-size="5"/>
        <!--精品课程-->
        <course-list title="精品课程" class-type="boutique" page-size="5"/>
        <!--折扣课程-->
        <course-list title="限时折扣课程" class-type="discount" page-size="5"/>

        <article-list title="头条精选"/>
      </div>
      <!--联系我们-->
      <div class="qq-list" :class="{'mobile-qq-list':isMobile}">
        <div v-if="isMobile" style="width: 100%;display: flex;">
          <div v-for="(item,index) in qqList" class="qq-item" :key="index" @click="showQQNum(item,index)">
            <div class="li-item-box">
              <a-icon type="qq"/>
              <!--              <a-icon type="phone"/>-->
              <div :title="item.remark" class="QQremark" :class="{'mobile-qq-remark':isMobile}">{{ item.remark }}
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(item,index) in qqList" :key="index" @click="showQQNum(item,index)">
            <!--            <div :id="`img${index}`" class="pc-qq-item" v-if="index !=qqList.length-1">-->
            <div :id="`img${index}`" class="pc-qq-item" v-if="item.remark!=='技术支持'">
              <div class="pc-qq-item-phone">
                <div class="pc-qq-item-phoneTitle">联系客服</div>
                <!--                默认第一个是QQ联系，第二个是电话联系-->
                <div class="pc-qq-item-pnoneNumber" v-if="index===0">
                  <a-icon type="qq"/>
                  {{ item.qq }}
                </div>
                <div class="pc-qq-item-pnoneNumber" v-if="index===1">
                  <a-icon type="phone"/>
                  {{ item.phone }}
                </div>
              </div>
              <img v-if="index===0" src="@assets/img/index/qq-icon.png" alt="">
              <a-icon v-if="index===1" class="phoneIcon" type="phone"/>
              <div style="display: none">客服{{ index + 1 }}</div>
            </div>
            <div v-else class="pc-qq-item" :id="`img${index}`">
              <div class="pc-qq-item-phone">
                <div class="pc-qq-item-phoneTitle">技术支持</div>
                <div class="pc-qq-item-pnoneNumber">
                  <a-icon type="phone"/>
                  {{ item.phone }}
                </div>
              </div>
              <img src="@assets/img/index/service-icon.png" alt="">
              <div style="display: none;width: 40px">技术支持</div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showMenu" class="num-menu">
        <div class="num-box" @click="copy">QQ:{{ selectData.qq }}</div>
        <div class="division"/>
        <div class="num-box" @click="callNum">电话:{{ selectData.phone }}</div>
      </div>
    </div>
    <Bottom v-if="!isMobile"/>
  </div>
</template>
<script>
import {memberDisplay} from "@utils/common";
import CourseList from "@components/course/CourseList";
import Carousel from "@components/carousel/Carousel"
import CourseLiveOnline from "@views/index/components/CourseLiveOnline"
import ArticleList from "@components/article/ArticleList";
import common from "../../mixin/common";
import {friendlyLink} from "@api/friendly-link-api";
import Bottom from "@components/layout/Bottom"
import {mapState} from 'vuex'
import IndexHeaderNav from "@views/index/components/IndexHeaderNav.vue";
import LayoutMobileHeader from "@components/layout/LayoutMobileHeader.vue";
import moment from "moment";
import {COMMIT_CHANGE_LOGIN_MODAL} from "@constants/mutation-type/login-mutation-type";
import {getMemberAfterLogin} from "../../api/personal-api";
import {showSuccessMsg} from "../../utils/msg";

export default {
  mixins: [common],
  components: {
    LayoutMobileHeader,
    IndexHeaderNav,
    CourseList, Carousel, CourseLiveOnline, ArticleList, Bottom
  },
  data() {
    return {
      showMenu: false,
      // 选中的客服对象
      selectData: {},
      qqList: [{}],
      isShowHeader: false,
      scrollTop: 0
    }
  },
  created() {
    friendlyLink("qq_list", 1, 3).then((res) => {
      if (res.code === 0) {
        this.qqList = res.rows.map(item => {
          // 字典值设定为 (QQ号 逗号 手机号)
          const numbersList = item.dictValue.replaceAll('，', ',').split(',')
          return {
            dictCode: item.dictCode,
            qq: numbersList[0],
            phone: numbersList[1],
            href: `http://wpa.qq.com/msgrd?v=3&uin=${numbersList[0]}&site=qq&menu=yes`,
            remark: item.remark
          }
        })
        console.log(this.qqList)
      }
    })
    // 该方法为在此函数中正确获取到用户登录状态
    this.$store.state.login.userInfoPromise.then(() => {
      this.showRegisterModel(this.isLogin)
      //如果之前是已登录状态，后又点击了vip链接，则直接调用vip赋值接口，vip链接用一次即清除
      if (this.isLogin && this.$route.query.memberRegistrationLinkCode) {
        getMemberAfterLogin(this.$route.query.memberRegistrationLinkCode).then(res => {
          if (res.code === 200) {
            showSuccessMsg("恭喜您成为vip")
          } else {
            setTimeout(() => {
              window.location.href = '/index'
            }, 100)
          }
        })
      }
    })
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    memberDisplay,
    openAndRenewalCallback() {
      if (this.isLogin) {
        this.$router.push(this.userInfo.memberFlag == 0 ? '/other/member-ship' : '/other/member-equity')
      } else {
        this.$store.commit(COMMIT_CHANGE_LOGIN_MODAL, {
          showLoginModal: true
        })
      }
    },
    // 处理会员过期时间
    formatTime() {
      return moment(this.userInfo.member.expiryTime).diff(moment(new Date()), 'days') + 1
    },
    // 获取页面滚动距离
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
    },
    showQQNum(item, index) {
      if (this.isMobile) {
        if (this.selectData?.dictCode === item.dictCode) {
          this.selectData = {}
          this.showMenu = false
          return
        }
        this.selectData = item
        this.showMenu = true
      } else {
        if (index === 0) {
          window.open(item.href, '_blank')
        }
      }
    },
    copy() {
      const inputNode = document.createElement("input");
      inputNode.setAttribute("value", this.selectData.qq);
      document.body.appendChild(inputNode);
      inputNode.select();
      document.execCommand("copy");
      document.body.removeChild(inputNode);
      this.$message.success('复制成功')
    },
    callNum() {
      window.location.href = `tel:${this.selectData.phone}`
    },
    //有vip链接且未登录时弹出注册框
    showRegisterModel(isLogin) {
      if (!isLogin && this.$route.query.memberRegistrationLinkCode) {
        this._changeRegisterModal(true)
      } else {
        this._changeRegisterModal(false)
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo,
      isLogin: state => state.login.isLogin
    })
  }
}
</script>

<style lang="less" scoped>
.sub-container {
  padding-bottom: 20px;
}

#img0:hover > img {
  display: none;
}

#img0:hover > div {
  display: inline-block !important;
}

//联系客服第一个不显示联系方式的框
#img0:hover > .pc-qq-item-phone {
  display: none !important;
}

#img1:hover > i {
  display: none;
}

#img1:hover > div {
  display: inline-block !important;
}

#img2:hover > img {
  display: none;
}

#img2:hover > div {
  display: inline-block !important;
}
.pc-qq-item-phone:hover {
  display: inline-block !important;
}

.pc-qq-item {
  background-color: #fff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  text-align: center;
  margin-bottom: 15px;
  display: flex;
  line-height: 15px;
  justify-content: center;
  align-items: center;
  color: #01AC74;
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.08);
  position: relative;

  .anticon-phone {
    rotate: 90deg;
    font-size: 26px;
    color: #3C3D3D;
  }
}

.vip-box {
  margin-top: 22px;
  height: 50px;
  background: url("~@/assets/img/index/vip-line.png");
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;

  img {
    width: 30px;
    margin-right: 8px;
  }

  span {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  button {
    margin-left: 3%;
    width: 72px;
    height: 26px;
    background: #6E421A;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    border-radius: 18px;
    border: none;
    color: #FFF;
    font-weight: 600;
    cursor: pointer;
  }
}

.index-main-container {
  background: #EDF1F7;
}

.top-bg {
  width: 100%;
  height: 295px;
  background: no-repeat url("~@/assets/img/index/index-top-bg.png");
  background-size: 100% 100%;

  > div {
    width: 1160px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;

    img {
      width: 212px;
      margin: 50px 0 50px;
    }
  }

  > div {
    width: 1160px;

  }
}

.mobile-top-bg {
  height: 150px;

  > div {
    img {
      margin: 20px 0 10px;
      width: 78px;
    }
  }

  > div {
    width: 90%;
  }
}

.main-container {
  width: 1160px;
  margin: -50px auto 0;
}

// qq列表
.qq-list {
  list-style: none;
  position: fixed;
  bottom: 35vh;
  right: 20px;
  z-index: 888;

  & > div:first-child {
    border-radius: 5px 5px 0 0;
  }

  & > div:hover {
    cursor: pointer;
  }

  i {
    font-size: 35px;
  }

  .contact-us {
    font-size: 13px;
    color: white;
    background-color: #009688;
    padding: 10px 7px 4px 7px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    text-align: center;
  }

  .qq-item {
    color: #fff;
    text-align: center;
    background-color: #00B278;
    border-top: 1px solid #e8e8e8;
    width: 100%;


    div {
      color: #fff;
    }

    .li-item-box {
      display: block;
      padding: 10px 7px 4px 7px;
    }
  }

  .qq-item:hover {
    color: white;
    background-color: #009688;

    i {
      color: white;
    }

    div {
      color: white;
    }
  }

  // 社区内容
  .association-box {
    position: absolute;
    right: 70px;
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    max-height: calc(20vh + 290px);
    //top: 0;
    //overflow-y: scroll;
    //width: 325px;
    ul {
      list-style: none;
      padding-left: 0;
      width: 100%;

      li {
        float: left;
        width: 150px;
        padding: 4px;
        height: 203px;

        img {
          max-width: 100%;
          border-radius: 3px;
          max-height: 100%;
        }
      }
    }
  }

  .association-box:hover {
    cursor: default;
  }
}


.mobile-qq-list {
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;

  .qq-item {
    border-left: 1px solid;
    border-radius: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;


    .li-item-box {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      padding: 0 6px;
      height: 40px;
      width: 100%;
      /*overflow: hidden;*/
      /*text-overflow: ellipsis;*/
      /*white-space: nowrap;*/


      i {
        font-size: 20px;
        margin-right: 8px;
      }


      .mobile-qq-remark {
        width: auto;
        height: 18px;
        /*line-height: 19px;*/
      }
    }
  }

  .qq-item:first-child {
    border: none;
    border-radius: 0;
  }
}

.mobile-index-container {
  padding-bottom: 30px;
}

.QQremark {
  width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-qq-list {
  .QQremark {
    width: 50%;
  }
}

.num-menu {
  position: fixed;
  z-index: 999;
  bottom: 41px;
  left: 0;
  height: 40px;
  width: 100%;
  border-radius: 20px 20px 0 0;
  background-color: #e6f7ff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;

  .num-box {
    flex-grow: 1;
    text-align: center;
  }

  .division {
    flex-shrink: 0;
    height: 60%;
    width: 1px;
    background-color: #009688;
  }
}

.mobile-main-container {
  width: 90% !important;
  margin-top: -83px;

  .vip-box {
    margin: 15px 0 10px 0;
    font-size: 12px;

    img {
      width: 16px;
    }

    span {
      font-size: 12px;
    }
  }
}

.pc-qq-item-phone {
  display: none;
  width: 170px;
  position: absolute;
  right: 55px;
  top: -2px;
  background-color: white;
  border-radius: 8px;
  padding: 8px 5px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 0.1vw 0.5vw 0px;

  .pc-qq-item-phoneTitle {
    width: 100%;
    font-size: 18px;
    font-weight: 500;
    color: #333333;

    .anticon-phone {
      font-size: 16px;
      font-weight: 400;
    }
  }

  .pc-qq-item-pnoneNumber {
    color: #E84055;
    margin-top: 10px;
    font-size: 20px;

    .anticon-phone {
      font-size: 16px;
      font-weight: 400;
    }

    .anticon-qq {
      color: #3C3D3D;
      font-size: 16px;
      font-weight: 400;
    }
  }
}

.pc-qq-item-phone::after {
  display: block;
  content: '';
  width: 0;
  height: 0;
  border: 5px solid white;
  rotate: 45deg;
  position: absolute;
  right: -5px;
  top: 38%;
}

</style>
